interface IProps {
    color?: string;
}

export const FileIcon = ({ color = "#3272be" }: IProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="31" viewBox="0 0 19 31" fill="none">
            <path d="M15.7922 7.04545V23.25C15.7922 26.3641 12.8166 28.8864 9.14286 28.8864C5.46909 28.8864 2.49351 26.3641 2.49351 23.25V5.63636C2.49351 3.69182 4.35532 2.11364 6.64935 2.11364C8.94338 2.11364 10.8052 3.69182 10.8052 5.63636V20.4318C10.8052 21.2068 10.0571 21.8409 9.14286 21.8409C8.22857 21.8409 7.48052 21.2068 7.48052 20.4318V7.04545H4.98701V20.4318C4.98701 22.3764 6.84883 23.9545 9.14286 23.9545C11.4369 23.9545 13.2987 22.3764 13.2987 20.4318V5.63636C13.2987 2.52227 10.3231 0 6.64935 0C2.97558 0 0 2.52227 0 5.63636V23.25C0 27.5336 4.08935 31 9.14286 31C14.1964 31 18.2857 27.5336 18.2857 23.25V7.04545H15.7922Z" fill={color} />
        </svg>
    )
}